// @flow

export type ToastShow = {
  type: 'TOAST_SHOW',
  payload: { name: string },
};

export function toastShow(name: string): ToastShow {
  return {
    type: 'TOAST_SHOW',
    payload: { name },
  };
}

export type ToastHide = {
  type: 'TOAST_HIDE',
  payload: { name: string },
};

export function toastHide(name: string): ToastHide {
  return {
    type: 'TOAST_HIDE',
    payload: { name },
  };
}
